import { defineRecipe } from '@plurall/elo-v3';

export const performanceComparisonChartRecipe = defineRecipe({
  className: 'performance-comparison-card__chart',
  base: {
    width: '100%',
    maxWidth: '640px',
    marginInline: 'auto',
    marginBottom: '50px',
    '& .recharts-xAxis .recharts-cartesian-axis-tick text': {
      fontSize: '12px',
    },
  },
});
